__turbopack_context__.v({
  "awardsWrp": "howItWorks-module-scss-module__oAwNEG__awardsWrp",
  "howItWorksContentContainer": "howItWorks-module-scss-module__oAwNEG__howItWorksContentContainer",
  "intro": "howItWorks-module-scss-module__oAwNEG__intro",
});
